import PropTypes from "prop-types"

const FloatingNavButton = ({ 
  handleClick, 
  icon, 
  style = {} 
}) => (
  <button 
    type="button"
    onClick={handleClick} 
    className={`fixed z-50 flex items-center -translate-y-1/2 rounded-md cursor-pointer w-14 h-14 bg-content1 top-1/2`} 
    style={style}
  >
    {icon}
  </button>          
)

FloatingNavButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  style: PropTypes.object
}

export default FloatingNavButton